/**
 * Empty states — the titles only. The hint under them stays the neutral,
 * actionable one: the title may have an opinion, the way forward may not.
 */

import type { SassContext } from '@gramas/shared'

type Line = (ctx: SassContext) => string

export const SCREENS: Readonly<Record<string, ReadonlyArray<Line>>> = {
  'empty_today.morning': [
    () => 'Tuščia. Net pusryčiai dar tik teorija.',
    () => 'Švaru. Įtartinai švaru.',
    () => 'Nieko. Rytas dar nekaltas.',
    () => 'Nulis įrašų. Kava nesiskaičiuoja? Skaičiuojasi.',
    () => 'Tuščias lapas. Laukiu pirmojo prisipažinimo.',
    () => 'Kol kas nieko. Gal dar net nevalgei — būna ir tokių rytų.',
  ],
  'empty_today.day': [
    () => 'Iki šiol nieko. Askezė ar amnezija?',
    () => 'Tuščias vidurdienis. Skrandis turi kitą versiją.',
    () => 'Nulis įrašų. Įspūdinga. Neįtikima.',
    () => 'Pietūs praėjo pro dienoraštį. Pro tave — vargu.',
    () => 'Vis dar nieko. Tyla įtartinai skani.',
    () => 'Na. Pusė dienos, nulis eilučių. Kas nors čia meluoja.',
  ],
  'empty_today.evening': [
    () => 'Visa diena, nė vieno įrašo. Net šventieji turėjo savo metraštininkus.',
    () => 'Tuščia iki vakaro. Kažkas valgė. Kažkas tyli.',
    () => 'Vakaras, o čia badmetis. Virtuvėje, spėju, ne.',
    () => 'Nulis įrašų iki sutemų. Netikiu.',
    () => 'Diena be duomenų. Vakarienė — paskutinis šansas.',
    () => 'Nieko. Rimtai, nieko? Visą dieną?',
  ],
  'empty_today.night': [
    () => 'Diena praėjo be įrašų. Paslaptys irgi dieta.',
    () => 'Nulis. Arba šventasis, arba tylenis.',
    () => 'Tuščia diena. Aš nusivylusi, bet mandagi.',
    () => 'Nieko neįrašyta. Rytoj pradėsim nuo švaraus. Vėl.',
    () => 'Diena liko be istorijos. Einu miegoti. Perkeltine prasme.',
    () => 'Tuščia. Tiek to. Būna ir tokių dienų.',
  ],
  'empty_trends.base': [
    () => 'Duomenų nėra. Tendencijos iš oro neatsiranda — reikia bent vienos dienos.',
    () => 'Grafikai tušti. Įrašyk dieną — gausi išvadas. Gal net švelnias.',
    () => 'Nėra ką rodyti. Statistika minta įrašais, ne pažadais.',
    () => 'Tuščia. Kreivėms reikia taškų, taškams — pietų.',
    () => 'Be duomenų nėra dramos. Įrašyk, ir sukursim.',
  ],
}

export const SCREENS_META: Readonly<Record<string, number>> = {
  'empty_today.morning': 2,
  'empty_today.day': 2,
  'empty_today.evening': 2,
  'empty_today.night': 2,
  'empty_trends.base': 1,
}
